import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/23/thumb-landscape.jpg"

const Post23 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">ISSEY MIYAKE／バオバオ／33 x32 x1cm</span>    
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>イッセイミヤケ（ISSEY MIYAKE）は1970年に三宅一生により日本で誕生したファッションブランド。<br></br>中でも代表的な「バオバオ」と呼ばれる幾何学模様のバッグを一度は目にしたことがあるという方も多いはず。今回はラクサスで人気のイッセイミヤケのバッグ10選をご紹介します！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ルーセント</h2>
          <p>バオバオシリーズの中で定番かつ最も人気があるのが「ルーセント」。光の当たり方と反射によって様々な表情を楽しめるバッグ。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/23/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/2.jpg" alt="" />
          </figure>
        </div>             
        <span className="text-center">ISSEY MIYAKE／バオバオ／33 x33 x1cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/3.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／33 x33 x1cm</span>

          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/4.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／34 x34 x1cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>プリズム</h2>
          <p>ルーセントよりも三角のピースが小さい「プリズム」は大人っぽく落ち着いた印象。使う年代を選ばず、どんな服装にも合わせやすいのが魅力。</p>          
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/23/5.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/6.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">ISSEY MIYAKE／バオバオ／39 x39 x1cm</span>                  
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/7.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／38 x38 x1cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/8.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／39 x38 x1cm</span> 
          </figure>
        </div>   
        <div className="text-max-width">
          <h2>トノーマット</h2>
          <p>マットで立体感のあるデザインが特徴的な「トノーマット」。ユニセックスに使えるデザインは、カジュアル・ボーイッシュなスタイルと相性抜群。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/23/9.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">ISSEY MIYAKE／バオバオ／26 x18 x3cm</span>     
        <div className="text-max-width">
          <h2>プリズムメタリック</h2>
          <p>パール塗料を使った「プリズムメタリック」は、金属のような光沢が印象的。コーデのワンポイントにアクセサリー感覚で取り入れたいアイテム。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/23/11.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/12.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">ISSEY MIYAKE／バオバオ／33 x32 x1cm</span>                    
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/13.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／39 x39 x1cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/14.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／27 x27 x1cm</span> 
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>レインボー</h2>
          <p>2013年のコレクションで発表以来、世界中から高い人気を誇る「レインボー」。名前のとおり見る角度で鮮やかに表情を変える虹のようなデザインは存在感抜群。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
                <StaticImage src="../../images/posts/23/15.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/16.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">ISSEY MIYAKE／バオバオ／32 x16 x8cm</span>   
        <Link to="https://laxus.co/app/pc/bags/issey" className="view-all-button">
          イッセイミヤケのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>ルーセントツイル</h2>
          <p>ツイル生地のような斜めの細かい布目が表現された「ルーセントツイル」。他のモデルとは一味違うマットでシンプルなデザインは、普段使いにも取り入れやすいアイテム。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/17.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">ISSEY MIYAKE／バオバオ／34 x33 x1cm</span>   
        <div className="text-max-width">
          <h2>ショルダーバッグ</h2>
          <p>使いやすいサコッシュタイプの「ショルダーバッグ」は、長財布や化粧ポーチを収納するのにぴったりなサイズ感。クラッチのように小脇に抱えてもこなれた印象に。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/19.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/20.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">ISSEY MIYAKE／バオバオ／23 x18 x1cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/21.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／34 x22 x1cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/22.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／28 x19 x4cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ハンドクラッチ</h2>
          <p>「ハンドクラッチ」は、ストラップを手首に掛けて持ち歩ける優れもの。また、中身に応じて形を変えることができ、使用しないときはフラットに畳んでおけるのも魅力。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/23.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/24.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">ISSEY MIYAKE／バオバオ／32 x16 x8cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/25.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／25 x15 x8cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/26.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／31 x15 x7cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>プラチナム</h2>
          <p>鏡のように光を反射する特殊な加工が施された「プラチナム」。太陽光の下では一段と輝くのでコーデのアクセントにもなり、持っているだけでお出かけが楽しくなりそう。</p>
        </div>
        <figure className="img-small">
              <StaticImage src="../../images/posts/23/27.jpg" alt="" />
        </figure>    
        <span className="text-center">ISSEY MIYAKE／バオバオ／39 x39 x1cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/23/28.jpg" alt="" />
            <span className="text-center">ISSEY MIYAKE／バオバオ／39 x39 x1cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/29.jpg" alt="" />
              <span className="text-center">ISSEY MIYAKE／バオバオ／30 x15 x4cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ロックマット</h2>
          <p>ライダースジャケットのような質感が印象的な「ロックマット」。ユニセックスなデザインはスニーカーやキャップなどスポーティーなアイテムと合わせるのがオススメ。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/30.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/23/31.jpg" alt="" />
          </figure>
        </div>     
        <span className="text-center">ISSEY MIYAKE／バオバオ／40 x31 x1cm</span>                         
        <div className="text-two-cloumn">
          <h2>コーデのワンポイントに<br className="pc"></br>イッセイミヤケのバオバオ</h2>
          <p>個性的なデザインが魅力のイッセイミヤケの「バオバオ」は、持っているだけでいつものコーデがカッコよく決まること間違いなし。ぜひオシャレの参考に♪</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/issey" className="view-all-button">
          イッセイミヤケのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post23

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 23}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
